import React from 'react'
import { Box, Card, CardContent, Grid, Typography } from '@mui/material'
import { TrendingUp, TrendingDown } from '@mui/icons-material'
import Chart from 'react-apexcharts'

const SPARKLINE_COLORS = ['#3B82F6', '#8B5CF6', '#06B6D4', '#F59E0B']

function SparklineCard({ item, color }) {
    const isPositive = item.invertColor ? item.variation <= 0 : item.variation >= 0
    const arrowColor = isPositive ? '#22C55E' : '#EF4444'

    const options = {
        chart: {
            type: 'area',
            sparkline: { enabled: true },
            animations: { enabled: true, easing: 'easeinout', speed: 800 },
        },
        stroke: { curve: 'smooth', width: 2 },
        fill: {
            type: 'gradient',
            gradient: { shadeIntensity: 1, opacityFrom: 0.3, opacityTo: 0.05, stops: [0, 100] },
        },
        colors: [color],
        tooltip: { enabled: false },
    }

    const series = [{ data: item.data }]

    return (
        <Card
            sx={{
                height: '100%',
                border: '1px solid #E2E8F0',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                transition: 'box-shadow 0.2s ease',
                '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.1)' },
            }}
        >
            <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <Typography variant="caption" sx={{ color: '#64748B', fontWeight: 500 }}>
                    {item.label}
                </Typography>
                <Typography variant="h6" sx={{ color: '#1E293B', fontWeight: 700, my: 0.5 }}>
                    {item.value}
                </Typography>
                <Chart options={options} series={series} type="area" height={40} />
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                    {isPositive ? (
                        <TrendingUp sx={{ fontSize: 14, color: arrowColor }} />
                    ) : (
                        <TrendingDown sx={{ fontSize: 14, color: arrowColor }} />
                    )}
                    <Typography variant="caption" sx={{ color: arrowColor, fontWeight: 600 }}>
                        {item.variation > 0 ? '+' : ''}{item.variation}%
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#94A3B8' }}>
                        {item.variationLabel || 'vs. mês anterior'}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    )
}

export default function SparklineCards({ data }) {
    return (
        <Grid container spacing={2}>
            {data.map((item, index) => (
                <Grid item xs={12} sm={6} md={3} key={item.label}>
                    <SparklineCard item={item} color={SPARKLINE_COLORS[index]} />
                </Grid>
            ))}
        </Grid>
    )
}
